import { gql } from "@apollo/client";

export const GetTransformTicket = gql`
  query GetTransformTicket($token: String!, $ticketID: ID!, $junctionID: ID!) {
    GetTransformTicket(
      token: $token
      ticketID: $ticketID
      junctionID: $junctionID
    ) {
      id
      ticketNo
      ticketDate
      reason
      type
      priority
      openRemarks
      lastRemarks
      poleNum
      status
      tableLevel
      resolvedDate
      closedDate
      closedDuration
      subsidiaryID
      companyID
      junction {
        id
        name
        alias
        jType
        arms
        icon
        poles
        code
        address
        vendorDetails {
          id
          desc
        }
      }
      vendorDetails {
        id
        desc
      }
      assignedUser {
        id
        name
      }
      ticketDetails {
        imagesPath
        createdUserDetails {
          id
          name
        }
      }
    }
  }
`;
